export const saveGenericData = (key, data) =>
  window.localStorage.setItem(key, JSON.stringify(data));

export const getGenericData = (key) => {
  const storagedValue = window.localStorage.getItem(key);
  if (storagedValue && storagedValue.toString() !== 'undefined' && storagedValue.toString() !== 'null') {
    return JSON.parse(window.localStorage.getItem(key));
  }

  return null;
}

export const clearGenericData = (key) => {
  window.localStorage.removeItem(key);
};
